import { useQuery } from "@tanstack/react-query"
import { API } from "config"

const useStatementReport = (report, start, end) => useQuery({ queryKey: ['statement', report, start, end], queryFn: async () => {
    const params = {
        start,
        end
    }
    const callback = await API.get(`/reports/${report}`, {params})
    return callback?.data
}, staleTime: 1000 * 60 * 60, gcTime: 1000 * 60 * 60 * 24})

export default useStatementReport
